import { Component } from '@angular/core';

@Component({
  selector: 'default-services',
  templateUrl: './services.component.html',
  styleUrls: []
})
export class ServicesComponent {
}
